/**
 * Shared utility functions for mapping dropdown options
 * Used in ChangeManagement.jsx to reduce duplication
 */

/**
 * Coerce a value to a string safe for React children. API sometimes returns
 * { id, name } objects where a string is expected; rendering those throws.
 */
export function safeDisplay(val) {
  if (val == null) return "";
  if (typeof val === "object" && !Array.isArray(val)) {
    return val.name ?? val.title ?? String(val.id ?? "");
  }
  return String(val);
}

/**
 * Maps budget_views array to budgetCodes format
 */
export const mapBudgetCodes = (budgetViews = []) =>
  (budgetViews ?? []).map((b) => ({
    id: b.id,
    code: b.flat_code || "",
    name: b.flat_name || "",
    cost_code_level_1: b.cost_code_level_1 || b.level_1 || "",
    cost_code_level_2: b.cost_code_level_2 || b.level_2 || "",
    category: b.category || b.cost_type || "",
  }));

/**
 * Maps change_events array to changeEvents format
 */
export const mapChangeEvents = (changeEvents = []) =>
  (changeEvents ?? []).map((ce) => ({
    id: ce.id,
    number: ce.number || "",
    title: ce.title || "",
  }));

/**
 * Maps patterns array to patterns format
 */
export const mapPatterns = (patterns = []) =>
  (patterns ?? []).map((p) => ({
    id: p.id,
    description: p.description || "",
    name: p.name || "",
  }));
